// extracted by mini-css-extract-plugin
module.exports =  {"container":"_772e1b1e50--container--AGPF5","item":"_772e1b1e50--item--OoHaF","link":"_772e1b1e50--link--mx_s3"};